import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export const FLOATING_CLOSE_PANEL_BUTTON_TOP = '1rem';
export const FLOATING_CLOSE_PANEL_BUTTON_RIGHT = '1rem';

interface FloatingClosePanelButtonProps {
  onClick: () => void;
  ariaLabel: string;
}

export const FloatingClosePanelButton: React.FC<FloatingClosePanelButtonProps> = ({
  onClick,
  ariaLabel,
}) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      variant="ghost"
      size="icon"
      className="floating-editor-control absolute z-20 h-10 w-10 shrink-0"
      style={{
        top: FLOATING_CLOSE_PANEL_BUTTON_TOP,
        right: FLOATING_CLOSE_PANEL_BUTTON_RIGHT,
      }}
    >
      <X className="h-5 w-5" />
    </Button>
  );
};
